module.exports = __webpack_public_path__ + "img/pdf-download.f3b49276.png";